export default __webpack_public_path__ + "static/media/In-store-pick-up.b4ae1b9a.svg";